import ShippingConfirmation from './ShippingConfirmation';
export default ShippingConfirmation;
